import { makeObservable, computed } from 'mobx';
import { AccountingStatementAppRuntimeDto } from '../types';
import { TabModel } from '../../common/types/TabModel';
import { IotaSessionsStore } from '../../common/stores';
import { SessionStoreBase } from '../../custom_shared/stores';
import { SessionsVisualStore } from '../../sessions/stores';

export default class SessionStore extends SessionStoreBase<AccountingStatementAppRuntimeDto> {
    constructor(
        tab: TabModel,
        iotaSessionsStore: IotaSessionsStore,
        private readonly sessionsVisualStore: SessionsVisualStore
    ) {
        super(tab, iotaSessionsStore);

        makeObservable(this, {
            settings: computed
        });
    }

    get settings() {
        return this.response?.settings ?? {};
    }

    getUserById(userId: string) {
        if (this.sessionsVisualStore?.allUsers[userId]) {
            return this.sessionsVisualStore.allUsers[userId];
        }

        return userId;
    }

    get userId() {
        return this.sessionsVisualStore.userId;
    }
}
